export { FallbackErrorBoundary };
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
function FallbackErrorBoundary({ children }) {
    /* TODO: either remove this or properly check whether env is DEV:
     *  - Safe check against process.env.NODE_ENV for server-side
     *  - Safe check against import.meta.env.DEV for client-side
     */
    return false /*import.meta.env.DEV*/ ? (React.createElement(QueryErrorResetBoundary, null, ({ reset }) => (React.createElement(ErrorBoundary, { onReset: reset, FallbackComponent: Fallback }, children)))) : (children);
}
function Fallback({ resetErrorBoundary, error }) {
    return (React.createElement("div", { style: pageStyle },
        React.createElement("div", { style: textStyle }, "There was an error."),
        React.createElement("button", { style: buttonStyle, onClick: () => resetErrorBoundary() }, "Try again"),
        /* TODO: either remove this or properly check whether env is DEV:
         *  - Safe check against process.env.NODE_ENV for server-side
         *  - Safe check against import.meta.env.DEV for client-side
         */
        false /*import.meta.env.DEV*/ && React.createElement("pre", null, getErrorStack(error))));
}
function getErrorStack(error) {
    if (error && error instanceof Error) {
        return error.stack;
    }
    return '';
}
const pageStyle = {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffe1e3',
    padding: 12,
};
const textStyle = {
    fontSize: 20,
    fontWeight: 500,
    color: '#f44250',
};
const buttonStyle = {
    fontSize: 18,
    fontWeight: 500,
    marginTop: 16,
    outline: 0,
    border: 0,
    color: '#272727',
    boxShadow: '0px 1px 2px 0px #ffc5c5',
    backgroundColor: '#fff',
    padding: '8px 12px',
    borderRadius: 16,
    cursor: 'pointer',
};
